module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 1074
// module chunks = 20